import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Loader2 } from 'lucide-react';
import ClientShell from './ClientShell';

export const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading, isAuthenticated } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-50">
        <Loader2 className="h-8 w-8 animate-spin text-[#F56F05]" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    // Redirect to appropriate dashboard based on role
    if (user?.role === 'admin' || user?.role === 'master_admin') {
      return <Navigate to="/admin/dashboard" replace />;
    } else if (user?.role === 'cleaner') {
      return <Navigate to="/cleaner/dashboard" replace />;
    } else if (user?.role === 'client') {
      return <Navigate to="/portal/dashboard" replace />;
    }
    return <Navigate to="/" replace />;
  }

  return children;
};

import AdminShell from '../admin/AdminShell';
import { useAdminHistoryTracker } from '../../hooks/useSmartBack';

const AdminHistoryTrackerMount = () => {
  useAdminHistoryTracker();
  return null;
};

export const AdminRoute = ({ children }) => (
  <ProtectedRoute allowedRoles={['admin', 'master_admin']}>
    <AdminHistoryTrackerMount />
    <AdminShell>{children}</AdminShell>
  </ProtectedRoute>
);

export const CleanerRoute = ({ children }) => (
  <ProtectedRoute allowedRoles={['cleaner']}>{children}</ProtectedRoute>
);

export const ClientRoute = ({ children }) => (
  <ProtectedRoute allowedRoles={['client']}><ClientShell>{children}</ClientShell></ProtectedRoute>
);

export default ProtectedRoute;
